import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getEtazhiBlackFridayPricesData } from 'shared/actions/etazhiBlackFriday';
import { getOffers } from 'shared/selectors/offers';

import type { TThunkDispatch } from 'shared/types/redux';

export function useGetOffersPrices(shouldFetchPromoPrices: boolean) {
  const dispatch = useDispatch<TThunkDispatch>();
  const offers = useSelector(getOffers);

  React.useEffect(() => {
    if (!shouldFetchPromoPrices) {
      return;
    }

    dispatch(getEtazhiBlackFridayPricesData());
  }, [dispatch, offers, shouldFetchPromoPrices]);
}
